import { Group, OutsideSpace, WorkSpace } from '../../core/types';
import { ProjectService } from '../../core/services/project.service';
import { Project } from '../../core/objects/project';
import { SharedMultistopGroups } from '../working-table.component';

export function getOldLoads(groups: Group[], index: number, stops: WorkSpace[]): Group[] {
  const stopIndex: number = calculateStopIndex(index);
  const previousStop: WorkSpace = stops[stopIndex];
  const cargoSpace1Groups: Group[] = previousStop.cargoSpaces[1]
    ? previousStop.cargoSpaces[1].groups
    : [];
  const previousStopGroups: Group[] = [...previousStop.cargoSpaces[0].groups, ...cargoSpace1Groups];
  const loadedLoadsNew: Group[] = groups.filter(
    (group1: Group): boolean =>
      previousStopGroups.find((group2: Group): boolean => group2.id === group1.id) !== undefined,
  );
  return index === 0 ? groups : loadedLoadsNew;
}

export function getNewLoads(
  groups: Group[],
  unloading: OutsideSpace,
  index: number,
  stops: WorkSpace[],
): [Group[], Group[]] {
  const stopIndex: number = calculateStopIndex(index);
  const previousStop: WorkSpace = stops[stopIndex];
  const cargoSpace1Groups: Group[] = previousStop.cargoSpaces[1]
    ? previousStop.cargoSpaces[1].groups
    : [];
  const previousStopGroups: Group[] = [...previousStop.cargoSpaces[0].groups, ...cargoSpace1Groups];
  const loadedLoadsNew: Group[] = groups.filter(
    (group1: Group): boolean =>
      previousStopGroups.find((group2: Group): boolean => group2.id === group1.id) === undefined,
  );
  const unloadedLoadsNew: Group[] = unloading.groups;
  return index === 0 ? [groups, unloading.groups] : [loadedLoadsNew, unloadedLoadsNew];
}

function calculateStopIndex(index: number): number {
  return index === 0 ? 0 : index - 1;
}

export function prepareMultiStopGroups(
  groups: Group[],
  unloading: OutsideSpace,
  stopIndex: number,
  projectService: ProjectService,
  project: Project,
  multiStopGroups: SharedMultistopGroups[],
  currentWorkSpace: number,
): void {
  groups = projectService.getProjectGroupOrder(groups);
  const newLoads: [Group[], Group[]] = getNewLoads(
    groups,
    unloading,
    stopIndex,
    project.workSpaces[currentWorkSpace].stops,
  );
  const oldLoads: Group[] = getOldLoads(
    groups,
    stopIndex,
    project.workSpaces[currentWorkSpace].stops,
  );
  const newGroups: Group[] = newLoads[0];
  const newUnloading: Group[] = newLoads[1];
  let loadedGroups: Group[] = stopIndex === 0 ? [] : oldLoads;
  const stop: WorkSpace =
    project.workSpaces[currentWorkSpace].stops[stopIndex > 1 ? stopIndex - 1 : stopIndex];
  const lastStopGroupsCargospace1: Group[] = stop.cargoSpaces[1] ? stop.cargoSpaces[1].groups : [];
  const lastStopGroups: Group[] = [
    ...project.workSpaces[currentWorkSpace].stops[stopIndex > 1 ? stopIndex - 1 : stopIndex]
      .cargoSpaces[0].groups,
    ...lastStopGroupsCargospace1,
  ];
  const isCurrentGroupsEmpty: boolean = groups.length === 0;
  const switchCurrentGroup: Group[] = isCurrentGroupsEmpty ? lastStopGroups : groups;
  if (newGroups.length === 0 && newUnloading.length === 0) {
    const unloadingSpace: OutsideSpace =
      project.workSpaces[currentWorkSpace].stops[stopIndex].unloadingSpace;
    unloadingSpace.groups = [];
    multiStopGroups.push({
      groups: oldLoads,
      unloading: unloadingSpace,
      stopIndex,
    });
  }
  newGroups.forEach((group: Group): void => {
    loadedGroups = [...loadedGroups, group];
    const unloadingSpace: OutsideSpace =
      project.workSpaces[currentWorkSpace].stops[stopIndex].unloadingSpace;
    multiStopGroups.push({
      groups: loadedGroups,
      unloading: unloadingSpace,
      stopIndex,
    });
  });

  let newUnloadingGroups: Group[] = [];
  const usedIds: number[] = [];
  newUnloading.forEach((group: Group): void => {
    newUnloadingGroups = [...newUnloadingGroups, group];
    const unloadingSpace: OutsideSpace = {
      ...project.workSpaces[currentWorkSpace].stops[stopIndex].unloadingSpace,
      groups: [...newUnloadingGroups],
    };
    usedIds.push(group.id);
    const currentGroupsWithoutUnloading: Group[] = switchCurrentGroup.filter(
      (group1: Group): boolean => {
        return !usedIds.includes(group1.id);
      },
    );
    multiStopGroups.push({
      groups: currentGroupsWithoutUnloading,
      unloading: unloadingSpace,
      stopIndex,
    });
  });
}
